var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavo0(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 50,
    viewBox: "0 0 54 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F3C709"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6243 0H34.374C38.7496 0 42.7919 2.33074 44.9766 6.11666L52.3576 18.8803C54.5423 22.6662 54.5423 27.3277 52.3576 31.1136L44.9827 43.8772C42.798 47.6631 38.7496 49.9938 34.3802 49.9938H19.6243C15.2488 49.9938 11.2065 47.6631 9.02181 43.8772L1.64695 31.1136C-0.537739 27.3277 -0.537739 22.6662 1.64695 18.8803L9.01564 6.11666C11.2065 2.33074 15.2488 0 19.6243 0Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavo0);
export default __webpack_public_path__ + "static/media/favo-0.78e253d9b5dc3b6b9b9faf56bca85519.svg";
export { ForwardRef as ReactComponent };